export default "__VITE_ASSET__03a298a9__"